import { IPayloadAction } from "../../../../react-core/Flux/PayloadStore";

import { SessionInfo } from "../../../../Wrap/Models/Models/Session/SessionInfo";

import { ExtendSessionClient } from "../../../../Wrap/Api/Session/ExtendSession";

import { ActionType } from "../../../../react-core/Flux/ActionType";
import { ExtendSessionDispatcher } from "./Variables";

export type IExtendSessionActions = IPayloadAction<SessionInfo>;

export class ExtendSessionActions {
    public static post(callback?: (val: SessionInfo) => void): void {
        const client = new ExtendSessionClient();
        const promise = client.post();
        ExtendSessionDispatcher.dispatch({ actionType: ActionType.Loading });

        promise.onSuccess((response) => {
            if (callback) {
                callback(response);
            }
            ExtendSessionDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: response,
            });
        });
    }
}
